<template>
    <div>
        <container :plate="'投资军团'" :active_path="'/invest/welfare'">
            <div class="base-warp">
                <div class="head">
                    <el-form :model="form" ref="form" label-width="80px" :inline="true" size="mini">
                        <el-form-item label="公司">
                            <el-select v-model="form.company" placeholder="请选择金融产品公司" clearable filterable allow-create default-first-option>
                                <el-option v-for="(item, index) in companys"
                                    :key="index"
                                    :label="item.name"
                                    :value="item.name">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="姓名">
                            <el-input v-model="form.name" placeholder="请填写用户姓名"></el-input>
                        </el-form-item>
                        <el-form-item label="手机号">
                            <el-input v-model="form.telephone" placeholder="请填写用户手机号"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="confirm" icon="el-icon-search">搜索</el-button>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" icon="el-icon-plus" @click="setuser">设置管理员</el-button>
                        </el-form-item>
                    </el-form>
                </div>
                <div class="table-box">
                    <el-table 
                    :data="tabledata" 
                    border 
                    size="mini"
                    :header-cell-style="{background:'#f7f7f7',color:'#999', textAlign: 'center', fontWeight: 'normal'}">
                        <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
                        <el-table-column prop="company" label="贷款公司" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="product" label="选择产品" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="amount" label="贷款金额" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="name" label="客户姓名" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="telephone" label="客户电话" show-overflow-tooltip></el-table-column>
                        <el-table-column label="处理状态" show-overflow-tooltip align="center">
                            <template slot-scope="s">
                                <span v-if="s.row.read" class="text-default">已处理</span>
                                <span v-else class="text-warning">未处理</span>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <el-pagination class="page-tion"
                    @current-change="currentChange"
                    layout="prev, pager, next"
                    :page-size="pagesize"
                    :total="total" background>
                </el-pagination>
            </div>
        </container>
        <router-view></router-view>
    </div>
</template>

<script>
import container from '../../../components/container.vue'
export default {
    components: { 
        container,
    },
    data() {
        return {
            form: {
                name: '',
                telephone: '',
                company: '',
            },
            companys: [
                {name: '武汉沃昂信息科技有限公司'},
            ],
            tabledata: [],
            pageNo: 1,
            pagesize: 14,
            total: 0,
        }
    },
    mounted () {
        this.gettabledata();
    },
    methods: {
        setuser() {
            this.$router.push({path: '/invest/welfare/setuser'})
        },
        confirm() {
            this.pageNo = 1;
            this.gettabledata();
        },
        gettabledata() {
            var params = {
                name: this.form.name,
                telephone: this.form.telephone,
                company: this.form.company,
                pageNo: this.pageNo,
                pagesize: this.pagesize
            }
            this.$api.getwelfarelist(params).then(
                data=>{
                    let {list, total} = data;
                    this.tabledata = list;
                    this.total = total;
                }
            )
        },
        currentChange(page) {
            this.pageNo = page;
            this.gettabledata();
        },
    },
}
</script>

<style lang="scss" scoped>

</style>